import template from "./message-list-item.html";
import "./message-list-item.less";

export class MessageListItem {
	constructor(uiHelpers) {
		this.uiHelpers = uiHelpers;
	}

	$onInit() {
		this.nonThisParticipants = this.header.participants.filter((item) => item.userId != this.thisUserid);

		this.primary = this.nonThisParticipants[0];
		this.isGroupContact = this.nonThisParticipants.length > 1;
		this.buildAvatarColors();
	}

	getInitials() {
		return `${this.primary.firstName.substring(0, 1)}${this.primary.lastName.substring(0, 1)}`;
	}

	buildAvatarColors() {
		const hexBkColor = this.uiHelpers.stringToHexColour(`${this.primary.firstName}${this.primary.lastName}`);

		this.avatarBkColor = this.uiHelpers.intToHexColorString(hexBkColor);
		this.avatarTextColor = this.uiHelpers.textColorForHexBk(hexBkColor);
	}

	getAllMembers() {
		return this.nonThisParticipants.map((item) => `${item.firstName} ${item.lastName}`).reduce((prev, curr) => { return `${prev}, ${curr}`; });
	}
}

export default angular
	.module("vesl.components.message-list-item", [])
	.component("messageListItem", {
		template,
		controller: MessageListItem,
		bindings: {
			header: "<",
			thisUserid: "<",
			highlight: "<"
		}
	}).name;
